export const DataType = {
    TEXT : 1,
    INTEGER : 2,
    DOUBLE : 3,
    BOOLEAN : 4,
    DATETIME : 5
};